import React from 'react';
import dugood1 from '../../../assets/icons/dugood1.svg';
import dugood2 from '../../../assets/icons/dugood2.svg';
import dugood3 from '../../../assets/icons/dugood3.svg';
import dugood4 from '../../../assets/icons/dugood4.svg';
import dugood5 from '../../../assets/icons/dugood5.svg';
import dugood6 from '../../../assets/icons/dugood6.svg';
import { useStyles } from '../conversation.styles';

export const ImageBlock = ({ className }: { className: string }): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={className}>
      <div className={classes.imgBlock}>
        <img src={dugood1} alt="" />
        <img src={dugood2} alt="" />
      </div>
      <div className={classes.imgBlock}>
        <img src={dugood3} alt="" />
        <img src={dugood4} alt="" />
      </div>
      <div className={classes.imgBlock}>
        <img src={dugood5} alt="" />
        <img src={dugood6} alt="" />
      </div>
    </div>
  );
};
